import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';

import APModal from 'components/Modal/APModal';

import './styles.scss';

function createPortalRoot() {
  const confirmRoot = document.createElement('div');
  confirmRoot.setAttribute('id', 'confirmation-root');
  return confirmRoot;
}

const ConfirmationModal = ({
  visible,
  name = 'confirmation',
  title,
  children,
  onClose,
  ...props
}) => {
  const bodyRef = useRef(document.querySelector('body'));
  const portalRootRef = useRef(document.getElementById('confirmation-root') || createPortalRoot());
  const inShadow = portalRootRef?.current?.shadowRoot;

  useEffect(() => {
    if (!inShadow) {
      if (document.getElementById('confirmation-root') === null) {
        bodyRef.current.appendChild(portalRootRef.current);
      }
      else {
        portalRootRef.current = document.getElementById('confirmation-root');
      }
    }

    const portal = inShadow ?
      portalRootRef.current.shadowRoot.getElementById('web-component-root') : portalRootRef.current;

    return () => {
      // Clean up the portal when menu component unmounts.
      if (!inShadow) portal.remove();
    };
  }, []);
  return createPortal(
    <div id="confirm-modal-root">
      <APModal
        open={visible}
        name={name}
        onClose={onClose}
        title={title}
        style={inShadow ? { backgroundColor: 'rgba(255, 255, 255, 0.6)' } : { zIndex: 1000 }}
        {...props}
      >
        {children}
      </APModal>
    </div>,
    inShadow ? portalRootRef.current.shadowRoot.getElementById('web-component-root') : portalRootRef.current,
  );
};

ConfirmationModal.protoTypes = {
  visible: PropTypes.bool,
  name: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.node,
  onClose: PropTypes.func,
};

export default ConfirmationModal;
